import 'css-chunksrc/client/scenes/workloads/header/creationMenu/styles.scss';export default {
  "creationMenu": "_creationMenu_1067l_1",
  "button": "_button_1067l_5",
  "icon": "_icon_1067l_25",
  "iconBox": "_iconBox_1067l_33",
  "menu": "_menu_1067l_42",
  "menuItem": "_menuItem_1067l_54",
  "menuText": "_menuText_1067l_67"
};